import { getAssignmentsFromTaskRawAssignment } from '../../../../utils/barnBoardHelper';

const matchesUser = (assignment, user, barnUsersMap) => {
  if (!user) return true;
  const selectedValue = user.auth0UserId || user.email || user.userFullName;
  if (!selectedValue) return true;
  return getAssignmentsFromTaskRawAssignment(assignment || '', barnUsersMap)
    .some((person) => [person.auth0UserId, person.email, person.userFullName].includes(selectedValue));
};

const filterPlannerReminderSuggestions = (suggestions, {
  selectedScheduleUser,
  selectedParticipantUser,
  barnUsersMap = {},
}) => Object.fromEntries(Object.entries(suggestions).map(([tagId, days]) => [tagId,
  Object.fromEntries(Object.entries(days).map(([day, entries]) => [day, entries.filter((suggestion) => {
    // Reminders without scheduled work stay visible; existing work must match the active staff filters.
    if (suggestion.action === 'schedule') return true;
    let assignment = suggestion.task?.currentEventStatus?.assignment;
    let participants = suggestion.task?.scheduleAssignment;
    if (suggestion.schedule) {
      const workflow = (suggestion.schedule.workflows || []).find((item) => Number(item.eventTemplateId) === Number(suggestion.template.id)
        && (item.tagIds || []).some((id) => Number(id) === Number(tagId)));
      assignment = workflow?.startingAssignment;
      participants = workflow?.scheduleAssignment || suggestion.schedule.assignment;
    }
    return matchesUser(assignment, selectedScheduleUser, barnUsersMap)
      && matchesUser(participants, selectedParticipantUser, barnUsersMap);
  })])),
]));

export default filterPlannerReminderSuggestions;
